import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconCategoryLayout({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity=".6" d="M8.5 3h5v10h-5V3z" fill="var(--label-tertiary)"/>
            <path fill={fill} d="M2.5 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5zM8 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11A.5.5 0 0 1 8 2zM13.5 12.083a.5.5 0 0 1 .5.5v.917a.5.5 0 0 1-1 0v-.917a.5.5 0 0 1 .5-.5zM13.5 8.417a.5.5 0 0 1 .5.5v1.833a.5.5 0 0 1-1 0V8.917a.5.5 0 0 1 .5-.5zM6.25 6.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-.5h-1V9a.5.5 0 0 1-1 0V7a.5.5 0 0 1 1 0v.5h1V7a.5.5 0 0 1 .5-.5zM13.5 4.75a.5.5 0 0 1 .5.5v1.833a.5.5 0 0 1-1 0V5.25a.5.5 0 0 1 .5-.5zM13.5 2a.5.5 0 0 1 .5.5v.917a.5.5 0 0 1-1 0V2.5a.5.5 0 0 1 .5-.5z"/>
        </svg>
    );
}

export default IconCategoryLayout;

